import { Typography } from "@mui/material";
import Grid from "./Grid";
import Spacebox from "./Spacebox";
import '../css/results.css'
import Flexbox from "./Flexbox";

const Results = ({ result }) => {
    const formatNum = (num) => parseInt(parseFloat(num).toFixed()).toLocaleString()

    const isSame = () => {

        if (result.lowMonths === 24 && (formatNum(result.lowMonthly) === formatNum(result.highMonthly)))
            return true
        return false
    }

    return (
        <div className="result-display">
            {/** 
             * 💰 Estimated Savings: You could save up to $8,000
             * 💳 New Monthly Payment: $250 – $500
             * ⏳ Estimated Program Duration: 24 – 48 months
            */}
            <Spacebox padding="10px" />
            <Grid grid={result.tier === 'tier 1' || isSame() ? 1 : 2} gap="20px">

                {/* FOR TIER 1 ONLY */}
                {result.tier === 'tier 1' && <div style={{ padding: 20, borderRadius: 10 }} className="option-1">
                    <Typography style={{ fontSize: '22px' }}>
                        <b>Program duration: <span style={{}} className="text-primary">24 Months</span></b>
                    </Typography>
                    <Spacebox padding="5px" />
                    <span style={{ fontSize: 35, fontWeight: 700 }} className="text-primary">${formatNum(result.highMonthly)}</span>
                    <Spacebox padding="5px" />
                    <Typography style={{ fontSize: '22px' }}>
                        <b>New monthly payment</b>
                    </Typography>
                </div>}

                {/* FOR Tier 2 - 4 */}
                {result.tier !== 'tier 1' && <div style={{ padding: 15, borderRadius: 10 }} className="option-1">
                    <Typography className=" option-text">
                        <b className="text-white">Option 1</b>
                    </Typography>
                    <Typography style={{ fontSize: '13px' }}>
                        <b>Program duration: <span style={{}} className="text-primary">24 Months</span></b>
                    </Typography>
                    <span style={{ fontSize: 30, fontWeight: 600, letterSpacing: '-1px' }} className="text-primary open-sans">${formatNum(result.highMonthly)}</span>
                    <Typography style={{ fontSize: '13px' }}>
                        <b>New monthly payment</b>
                    </Typography>
                </div>}
                {(result.tier !== 'tier 1' && !isSame()) && <div style={{ padding: 15, borderRadius: 10 }} className="option-2">
                    <Typography className=" option-text">
                        <b className="text-white">Option 2</b>
                    </Typography>
                    <Typography style={{ fontSize: '13px' }}>
                        <b>Program duration: <span style={{}} className="text-primary">{result.lowMonths} Months</span></b>
                    </Typography>
                    <span style={{ fontSize: 30, fontWeight: 600, letterSpacing: '-1px' }} className="text-primary open-sans">${formatNum(result.lowMonthly)}</span>
                    <Typography style={{ fontSize: '13px' }}>
                        <b>New monthly payment </b>
                    </Typography>
                </div>}
                <div style={{ gridColumn: '1/3', marginTop: '20px' }}>
                    <div style={{ padding: "5px 100px", borderRadius: "10px", width: 'fit-content', margin: 'auto' }} className="debt-amount-1">
                        <Typography className="option-text">
                            <b className="text-white">Your Unsecured Debt Profile</b>
                        </Typography>
                        <Flexbox alignItems="center" justifyContent="center">
                            <Typography style={{ fontSize: '30px' }}>
                                <b style={{ fontWeight: 600, letterSpacing: '-2px' }} className="trade-red open-sans">${formatNum(result.debtAmount)}</b>
                            </Typography>
                        </Flexbox>
                    </div>
                </div>
                <div style={{ gridColumn: '1/3' }}>
                    <div style={{ padding: "5px 100px", borderRadius: "10px", width: 'fit-content', margin: 'auto' }} className="estimate-1">
                        <Typography className="" style={{ fontSize: '16px', opacity: .8, textAlign: 'center' }}>
                            <b className="text-black">Estimated Saving:</b>
                        </Typography>
                        <Flexbox alignItems="center" justifyContent="center">
                            <small style={{ fontWeight: 800 }}>Save <br />Up to</small>
                            <Spacebox padding="5px" />
                            <Typography style={{ fontSize: '55px' }}>
                                <b style={{ fontWeight: 700, letterSpacing: '-4px' }} className="text-primary open-sans">${formatNum(result.estimatedSaving)}</b>
                            </Typography>
                        </Flexbox>
                    </div>
                </div>
            </Grid>
        </div>
    );
}

export default Results;